/* PDLYTE concept theme behaviour: packs + Save £, add to bag with pack discount code, sticky bar,
   countdowns, stock bar, gallery, review rail. No pricing is changed here; discounts come from Shopify codes. */
(() => {
  'use strict';
  if (window.pdxLoaded) return;
  window.pdxLoaded = true;

  const money = (cents, currency) => new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency || 'GBP' }).format(Number(cents) / 100);
  const base = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.addEventListener('click', (event) => {
    const step = event.target.closest('[data-pdx-reasons-step]');
    if (step) {
      const rail = step.closest('.pdx-reasons-cards').querySelector('.pdx-reasons-cards__rail');
      rail.scrollBy({left: Number(step.dataset.pdxReasonsStep) * (rail.firstElementChild.getBoundingClientRect().width + 20), behavior: reduced() ? 'instant' : 'smooth'});
      return;
    }
    const button = event.target.closest('.pdx-marquee__toggle');
    if (!button) return;
    const paused = button.closest('[data-pdx-marquee]').classList.toggle('is-paused');
    button.setAttribute('aria-pressed', String(paused));
    button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
    button.querySelector('[data-pdx-motion-icon]').textContent = paused ? '▷' : 'Ⅱ';
  });

  /* ---------- Packs ---------- */
  const initPacks = (packs) => {
    if (packs.dataset.init) return;
    packs.dataset.init = '1';
    const root = packs.closest('[data-pdx-product]');
    const form = document.getElementById(packs.dataset.formId);
    if (!root || !form) return;
    const currency = packs.dataset.currency;
    const tiers = packs.hasAttribute('data-pdx-subscription-tiers');
    const atc = form.querySelector('[data-pdx-atc]');
    const sticky = root.querySelector('[data-pdx-sticky]');
    const requested = new URLSearchParams(location.search).get('pack');
    if (requested) {
      const el = packs.querySelector(`[data-pdx-pack][data-qty="${requested}"] input`);
      if (el) el.checked = true;
    }
    const requestedPlan = new URLSearchParams(location.search).get('selling_plan');
    if (requestedPlan) {
      const choice = [...form.querySelectorAll('[data-pdx-subscription]')].find(input => input.value === requestedPlan);
      if (choice) choice.checked = true;
    }
    const modeToggle = root.querySelector('[data-pdx-purchase-toggle]');
    const syncMode = (mode, quantity) => {
      packs.dataset.mode = mode;
      let choice;
      packs.querySelectorAll('[data-purchase-mode]').forEach(pack => {
        const active = pack.dataset.purchaseMode === mode;
        pack.hidden = !active;
        const input = pack.querySelector('input[type="radio"]');
        input.disabled = !active || pack.dataset.planAvailable === 'false';
        if (active && !input.disabled && pack.dataset.qty === quantity) choice = input;
      });
      choice ||= packs.querySelector('[data-purchase-mode="' + mode + '"] input:not(:disabled)');
      if (choice) choice.checked = true;
      const legend = packs.querySelector('[data-pdx-mode-legend]');
      if (legend) legend.textContent = mode === 'subscription' ? packs.dataset.subscriptionLegend : packs.dataset.onceLegend;
      if (modeToggle) modeToggle.textContent = mode === 'subscription' ? modeToggle.dataset.onceLabel : modeToggle.dataset.subscribeLabel;
      const assurance = root.querySelector('[data-pdx-refill-assurance]');
      if (assurance) assurance.hidden = mode !== 'subscription';
    };
    if (tiers) {
      const current = packs.querySelector('input[type="radio"]:checked')?.closest('[data-pdx-pack]');
      syncMode(current?.dataset.purchaseMode || 'subscription', current?.dataset.qty || '1');
    }
    const selected = () => {
      const input = packs.querySelector('input[type="radio"]:checked');
      return input ? input.closest('[data-pdx-pack]') : null;
    };
    const update = () => {
      const pack = selected();
      if (!pack) return;
      const subscription = form.querySelector('[data-pdx-subscription]:checked');
      if (!tiers && subscription && pack.dataset.qty !== '1') {
        packs.querySelector('[data-pdx-pack][data-qty="1"] input').checked = true;
        update();
        return;
      }
      const total = subscription ? Number(subscription.dataset.planPrice) : Number(pack.dataset.total);
      const regular = Number(pack.dataset.regular);
      const saving = regular - total;
      packs.classList.toggle('pdx-packs--subscription', Boolean(subscription) && !packs.hasAttribute('data-pdx-integrated-purchase'));
      root.querySelectorAll('[data-pdx-delivery-note]').forEach(el => {
        el.textContent = total >= Number(packs.dataset.freeThreshold) ? el.dataset.free : el.dataset.paid.replace('[total]', money(total + 595, currency));
      });
      const planInput = form.querySelector('[data-pdx-selling-plan]');
      if (planInput) { planInput.disabled = !subscription; planInput.value = subscription ? subscription.value : ''; }
      const terms = form.querySelector('[data-pdx-subscription-terms]');
      if (terms) terms.hidden = !subscription;
      const quantity = form.querySelector('[data-pdx-quantity]');
      if (quantity) quantity.value = pack.dataset.qty;
      root.querySelectorAll('[data-pdx-day-price]').forEach(el => { el.textContent = money(total / (Number(pack.dataset.qty) * 30), currency); });
      packs.querySelectorAll('[data-pdx-pack]').forEach((el) => el.classList.toggle('is-selected', el === pack));
      root.querySelectorAll('[data-pdx-price]').forEach((el) => (el.textContent = money(total, currency)));
      root.querySelectorAll('[data-pdx-compare]').forEach((el) => { el.hidden = !(regular > total); el.textContent = regular > total ? money(regular, currency) : ''; });
      root.querySelectorAll('[data-pdx-save]').forEach((el) => (el.textContent = saving > 0 ? 'Save ' + money(saving, currency) : ''));
      root.querySelectorAll('[data-pdx-save-wrap]').forEach((el) => (el.hidden = !(saving > 0)));
      root.querySelectorAll('[data-pdx-single-wrap]').forEach((el) => (el.hidden = saving > 0));
      root.querySelectorAll('[data-pdx-atc-price]').forEach((el) => (el.textContent = money(total, currency)));
      root.querySelectorAll('[data-pdx-unlock]').forEach((el) => {
        const need = Number(el.dataset.pdxUnlock || 0);
        const qtyNeed = Number(el.dataset.pdxUnlockQty || 0);
        const ok = (need ? total >= need : true) && (qtyNeed ? Number(pack.dataset.qty) >= qtyNeed : true);
        el.classList.toggle('is-unlocked', ok);
        const state = el.querySelector('[data-pdx-unlock-state]');
        if (state) state.textContent = ok ? 'Unlocked' : 'Locked';
      });
      const note = packs.querySelector('[data-pdx-note]');
      if (note && subscription) note.textContent = subscription.dataset.planNote;
      else if (note) note.textContent = saving > 0 ? 'One-time purchase. Your ' + money(saving, currency) + ' saving is applied in your bag.' : 'One-time purchase. No subscription.';
      if (sticky) {
        const p = sticky.querySelector('[data-pdx-sticky-price]');
        const l = sticky.querySelector('[data-pdx-sticky-label]');
        if (p) p.textContent = money(total, currency);
        if (l) l.textContent = subscription ? subscription.dataset.planName : (pack.dataset.label || '');
        const b = sticky.querySelector('button');
        if (b) b.disabled = !atc || atc.disabled;
      }
    };
    const flavour = form.querySelector('[data-pdx-set-flavour]');
    if (flavour) flavour.addEventListener('change', () => {
      const id = Number(flavour.value);
      packs.querySelectorAll('[data-pdx-pack]').forEach((pack) => {
        const script = pack.querySelector('[data-pdx-items]');
        if (!script) return;
        const items = JSON.parse(script.textContent);
        items[Number(flavour.dataset.itemIndex || 0)].id = id;
        script.textContent = JSON.stringify(items);
      });
    });
    packs.addEventListener('change', update);
    if (tiers && modeToggle) modeToggle.addEventListener('click', () => {
      const quantity = selected()?.dataset.qty || '1';
      syncMode(packs.dataset.mode === 'subscription' ? 'once' : 'subscription', quantity);
      update();
      packs.querySelector('input:checked')?.focus({ preventScroll: true });
      packs.scrollIntoView({ block: 'nearest', behavior: reduced() ? 'instant' : 'smooth' });
    });
    const variantSelector = form.querySelector('[data-pdx-variant-selector]');
    const variantData = form.querySelector('[data-pdx-variant-data]');
    if (variantSelector && variantData) {
      const variants = JSON.parse(variantData.textContent);
      variantSelector.addEventListener('change', () => {
        const choice = variants.find(v => v.id === Number(variantSelector.querySelector('input:checked').value));
        if (!choice) return;
        form.querySelector('input[name="id"]').value = choice.id;
        variantSelector.querySelectorAll('[data-pdx-variant-choice]').forEach(label => label.classList.toggle('is-selected', label.querySelector('input').checked));
        packs.querySelectorAll('[data-pdx-pack]').forEach(pack => {
          const q = Number(pack.dataset.qty);
          const sub = pack.querySelector('[data-pdx-subscription]');
          const plan = choice.plans.find(p => !sub || p.id === Number(sub.value));
          const regular = choice.price * q;
          const total = sub && plan ? plan.price * (tiers ? q : 1) : tiers ? regular : regular - Math.floor(choice.price * Number(pack.dataset.percent) / 100) * q;
          pack.dataset.regular = regular;
          pack.dataset.total = total;
          pack.dataset.saving = regular - total;
          pack.querySelector('[data-pdx-items]').textContent = JSON.stringify([{ id: choice.id, quantity: q }]);
          if (sub && plan) sub.dataset.planPrice = total;
          pack.querySelector('.pdx-pack__price strong').textContent = money(total, currency);
          const was = pack.querySelector('.pdx-pack__price s');
          if (was) was.textContent = money(regular, currency);
        });
        if (choice.image) {
          root.querySelectorAll('[data-pdx-variant-media] img').forEach(img => {
            img.src = choice.image;
            img.removeAttribute('srcset');
            img.alt = choice.title;
          });
          const stickyImage = sticky && sticky.querySelector('img');
          if (stickyImage) { stickyImage.src = choice.image; stickyImage.removeAttribute('srcset'); }
        }
        if (atc) atc.disabled = !choice.available;
        const url = new URL(location.href); url.searchParams.set('variant', choice.id); history.replaceState(null, '', url);
        update();
      });
    }
    const purchaseOptions = form.querySelector('[data-pdx-purchase-options]');
    if (purchaseOptions) purchaseOptions.addEventListener('change', update);
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (form.dataset.busy) return;
      const pack = selected();
      if (!pack || (atc && atc.disabled)) return;
      const items = JSON.parse(pack.querySelector('[data-pdx-items]').textContent);
      const subscription = form.querySelector('[data-pdx-subscription]:checked');
      if (subscription) items.forEach(item => { item.selling_plan = Number(subscription.value); });
      const error = packs.querySelector('[data-pdx-error]');
      form.dataset.busy = '1';
      const oldText = atc ? atc.innerHTML : '';
      if (atc) { atc.disabled = true; atc.innerHTML = '<span>Adding…</span>'; }
      if (error) error.hidden = true;
      try {
        const cartUI = await import('@theme/pdlyte-cart');
        const add = await fetch(base() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        const added = await add.json();
        if (!add.ok) throw new Error(added.description || 'Could not add this pack. Please try again.');
        const cartRes = await fetch(base() + 'cart.js', { headers: { Accept: 'application/json' } });
        const cart = await cartRes.json();
        const retained = (cart.discount_codes || []).filter((d) => !d.code.startsWith('PDLYTE-CONCEPT-')).map((d) => d.code);
        if (!subscription && pack.dataset.code) retained.push(pack.dataset.code);
        const upd = await fetch(base() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: retained.join(','), sections: cartUI.sectionIds(), sections_url: location.pathname }) });
        if (!upd.ok) throw new Error('Your items were added. Please check your bag.');
        await cartUI.openUpdatedCart(await upd.json());
      } catch (e) {
        if (error) { error.textContent = e.message; error.hidden = false; }
      } finally {
        if (atc) { atc.disabled = false; atc.innerHTML = oldText; }
        delete form.dataset.busy;
      }
    }, true);
    if (sticky && atc) {
      document.body.appendChild(sticky);
      root._pdxSticky = sticky;
      sticky.querySelector('button').addEventListener('click', () => { if (!atc.disabled) form.requestSubmit(); });
      if ('IntersectionObserver' in window) {
        root._pdxIO = new IntersectionObserver(([entry]) => {
          sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        }, { threshold: 0 });
        root._pdxIO.observe(atc);
      }
    }
    update();
  };

  /* ---------- Countdown (cycles every N hours, local) ---------- */
  const initCountdown = (el) => {
    if (el.dataset.init) return;
    el.dataset.init = '1';
    const hours = Number(el.dataset.pdxCountdown || 24);
    const mode = el.dataset.pdxMode || 'cycle';
    const cutoff = Number(el.dataset.pdxCutoff || 14);
    const h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      let remain;
      const now = new Date();
      if (mode === 'cutoff') {
        const t = new Date(now); t.setHours(cutoff, 0, 0, 0);
        if (t <= now) t.setDate(t.getDate() + 1);
        remain = Math.floor((t - now) / 1000);
      } else {
        const period = hours * 3600;
        remain = period - (Math.floor(now.getTime() / 1000) % period);
      }
      if (h) h.textContent = pad(Math.floor(remain / 3600));
      if (m) m.textContent = pad(Math.floor((remain % 3600) / 60));
      if (s) s.textContent = pad(remain % 60);
    };
    tick();
    setInterval(tick, 1000);
  };

  /* ---------- Stock bar ---------- */
  const initStock = (el) => {
    if (el.dataset.init) return;
    el.dataset.init = '1';
    const fill = el.querySelector('[data-pdx-stock-fill]');
    const pct = Number(el.dataset.pdxStock || 80);
    if (!fill) return;
    requestAnimationFrame(() => { fill.style.width = pct + '%'; });
  };

  /* ---------- Gallery ---------- */
  const initGallery = (gal) => {
    if (gal.dataset.init) return;
    gal.dataset.init = '1';
    const main = gal.querySelector('[data-pdx-gallery-main] img');
    const slides = gal.querySelectorAll('[data-pdx-slide]');
    const thumbs = gal.querySelectorAll('[data-pdx-thumb]');
    const prev = gal.querySelector('[data-pdx-gallery-prev]');
    const next = gal.querySelector('[data-pdx-gallery-next]');
    let index = 0;
    const show = (i) => {
      if (!thumbs.length) return;
      index = (i + thumbs.length) % thumbs.length;
      const t = thumbs[index];
      if (slides.length) {
        slides.forEach((slide, j) => { slide.hidden = j !== index; });
        const number = gal.querySelector('[data-pdx-slide-number]');
        const label = gal.querySelector('[data-pdx-slide-label]');
        const status = gal.querySelector('[data-pdx-gallery-status]');
        if (number) number.textContent = String(index + 1).padStart(2, '0');
        if (label) label.textContent = t.dataset.label;
        if (status) status.textContent = `${index + 1} / ${slides.length}: ${t.dataset.label}`;
        if (!reduced() && slides[index].animate) slides[index].animate([{ opacity: .25, transform: 'translateY(6px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 250, easing: 'ease-out' });
      } else if (main) { main.src = t.dataset.src; main.srcset = t.dataset.srcset || ''; main.alt = t.dataset.alt || ''; }
      thumbs.forEach((el, j) => el.setAttribute('aria-current', j === index ? 'true' : 'false'));
      if (!slides.length) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduced() ? 'instant' : 'smooth' });
    };
    thumbs.forEach((t, i) => t.addEventListener('click', () => show(i)));
    gal.addEventListener('keydown', (event) => {
      if (!event.target.closest('[data-pdx-thumb]')) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1)); thumbs[index].focus({ preventScroll: true });
      }
    });
    if (prev) prev.addEventListener('click', () => show(index - 1));
    if (next) next.addEventListener('click', () => show(index + 1));
    let startX = null, startY = null;
    const mainWrap = gal.querySelector('[data-pdx-gallery-main]');
    if (mainWrap) {
      mainWrap.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; startY = e.touches[0].clientY; }, { passive: true });
      mainWrap.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        const dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.25) show(index + (dx < 0 ? 1 : -1));
        startX = null;
      });
    }
  };

  /* ---------- Rails (reviews) ---------- */
  const initRail = (rail) => {
    if (rail.dataset.init) return;
    rail.dataset.init = '1';
    const track = rail.querySelector('[data-pdx-rail-track]');
    if (!track) return;
    rail.querySelectorAll('[data-pdx-rail-step]').forEach((b) => b.addEventListener('click', () => {
      const card = track.firstElementChild;
      const step = card ? card.getBoundingClientRect().width + 16 : 320;
      track.scrollBy({ left: Number(b.dataset.pdxRailStep) * step, behavior: reduced() ? 'instant' : 'smooth' });
    }));
  };

  /* ---------- Show more ---------- */
  const initMore = (btn) => {
    if (btn.dataset.init) return;
    btn.dataset.init = '1';
    btn.addEventListener('click', () => {
      const target = document.getElementById(btn.getAttribute('aria-controls'));
      if (!target) return;
      target.querySelectorAll('[hidden]').forEach((el) => (el.hidden = false));
      btn.hidden = true;
    });
  };

  const initReveal = (el) => {
    if (el.dataset.pdxRevealReady || reduced() || !('IntersectionObserver' in window)) return;
    el.dataset.pdxRevealReady = '1';
    el.classList.add('pdx-reveal-pending');
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      el.classList.add('is-visible');
      observer.disconnect();
    }, { rootMargin: '0px 0px 40px 0px', threshold: 0.04 });
    el._pdxRevealObserver = observer;
    observer.observe(el);
  };

  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-pdx-packs]').forEach(initPacks);
    scope.querySelectorAll('[data-pdx-countdown]').forEach(initCountdown);
    scope.querySelectorAll('[data-pdx-stock]').forEach(initStock);
    scope.querySelectorAll('[data-pdx-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-pdx-rail]').forEach(initRail);
    scope.querySelectorAll('[data-pdx-more]').forEach(initMore);
    scope.querySelectorAll('[data-pdx-reveal]').forEach(initReveal);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
  document.addEventListener('shopify:section:load', (e) => initialise(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll('[data-pdx-reveal]').forEach(el => { if (el._pdxRevealObserver) el._pdxRevealObserver.disconnect(); });
    const root = e.target.querySelector('[data-pdx-product]');
    if (root) { root._pdxIO && root._pdxIO.disconnect(); root._pdxSticky && root._pdxSticky.remove(); }
  });
})();

